// Mount the two roots of the image-search feature (no-ops on pages without them).
//
// Two islands rather than one because there are two mount points a long way apart in the
// document: the button sits beside the search input in `Front.tsx`, the chip at the top of
// the sidebar in `Chrome.tsx`. They share `./store`, not a component tree.
import { Islands } from "@brave-new-world/shared";
import { mountIsland } from "../../ui/islands";
import { SearchImageButton } from "./SearchImageButton";
import { SearchImageChip } from "./SearchImageChip";
import { applySeedFromUrl } from "./seedFromUrl";
import { initSearchImageDropzone } from "./dropzone";

export function initSearchImage(): void {
  mountIsland(Islands.searchImage, SearchImageButton, {});
  mountIsland(Islands.searchImageChip, SearchImageChip, {});
  initSearchImageDropzone();
  // `/search?like=<artworkId>` — the "Open as a search" button on an artwork's "More like
  // this". Runs after the islands mount so the chip is listening when the store is set.
  void applySeedFromUrl();
}
